import { useEffect, useRef, useState } from "react";

export default function AboutPreview() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) setVisible(true);},
      { threshold: 0.05 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="bg-background">
      <div className="grid grid-cols-1 md:grid-cols-2 min-h-[600px] md:min-h-screen">
        <div className={`px-8 md:px-16 py-16 md:py-0 flex flex-col justify-center bg-white transition-all duration-700 ${visible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-6"}`}>
          <div>
            <h2 className="font-heading text-4xl md:text-5xl font-light leading-[1.2] mb-6 text-foreground">
              Bli kjent med oss,
              <br />
              håndverk og arkitektur
            </h2>
            <p className="font-body leading-relaxed text-foreground/70 mb-8" style={{ fontSize: "23px" }}>
              Vi er et lite team som virkelig liker det vi driver med. Utforsk prosjektene våre, så blir du også litt kjent med oss.
            </p>
            <a
              href="/om-oss"
              className="inline-block text-base tracking-widest-xl font-body uppercase px-8 py-3.5 border border-foreground/30 text-foreground hover:bg-foreground hover:text-white transition-all duration-300">
              Om oss
            </a>
          </div>
        </div>

        <div className={`relative overflow-hidden transition-all duration-700 ${visible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-6"}`} style={{ transitionDelay: "80ms" }}>
          <img src="https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/9545b0632_NJnatur.png"
          alt="LYKKE handverket og arkitektur"
          className="w-full h-full object-cover"
          loading="lazy" />
          
        </div>
      </div>
    </section>);

}